import { Component, ElementRef, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { AcLineSegmentType, AcLineType } from '../../../../../models/ac-line-segment.model';
import { Voltage } from '../../../../../enums/voltage';
import { GeographicalRegion } from '../../../../../models/geographical-region.model';
import { SubstationTemplateForSelectDataOut } from '../../../../../models/substation-template.model';
import { SearchSubstationDto, SelectSubstationDto } from '../../../../../models/substation-template-instance.model';
import { GeographicalRegionService } from '../../../../../services/geographical-region.service';
import { ToastrService } from 'ngx-toastr';
import { CimSubstationService } from '../../../../../services/cim-substation.service';
import { PowerTransformerService } from '../../../../../services/power-transformer.service';
import { EditPowerTransformerDto, SelectPowerTransformerDto } from '../../../../../models/power-transformer.model';
import { BaseVoltageService } from '../../../../../services/base-voltage.service';
import { AssetRating } from '../../../../../models/asset-rating.model';
import { AssetRatingService } from '../../../../../services/asset-rating.service';
import { ObjectDropdownComponent } from '../../../../common/object-dropdown/object-dropdown.component';
import { UtilitySharedService } from '../../../../../services/shared/utility-shared.service';

@Component({
  selector: 'lib-nec-add-edit-modal-power-transformer',
  templateUrl: './nec-add-edit-modal-power-transformer.component.html',
  styleUrls: ['./nec-add-edit-modal-power-transformer.component.scss', '../../../network-entity-classes.component.scss'],
  standalone: false
})
export class NecAddEditModalPowerTransformerComponent implements OnInit {
  @Output() ptSaved = new EventEmitter<void>();
  @Input() isOpenedFromSubstation: boolean = false;
  @Input() substationTemplateInstanceId: any;
  @Input() substationVoltage: any;
  @Input() selectedPtId: { value: number | null} | null = null;
  @Input() assetRatings: AssetRating[] = [];
  isEdit: boolean = false;
  Voltage = Voltage;
  AcLineSegmentType = AcLineSegmentType;
  initialVoltage: Voltage.LV | null = Voltage.LV;
  initialAcLineSegment: AcLineType.Incoming | null = AcLineType.Incoming;
  geographicalRegionValue: GeographicalRegion | null = null;
  substationTemplateValue: SubstationTemplateForSelectDataOut | null = null;
  geoRegions: GeographicalRegion[] = [];
  substationTemplateOptions: SubstationTemplateForSelectDataOut[] = [];
  substationOptions: SelectSubstationDto[] = [];
  powerTransformerOptions: SelectPowerTransformerDto[] = [];
  filteredAssetRatings: AssetRating[] = [];
  dataIn: SearchSubstationDto = new SearchSubstationDto();
  @ViewChild('closeEditModal') closeEditModal!: ElementRef;
  @ViewChild('substationTemplateDropdown') substationTemplateDropdown!: ObjectDropdownComponent;
  @ViewChild('substationTemplateInstanceDropdown') substationTemplateInstanceDropdown!: ObjectDropdownComponent;
  @ViewChild('assetRatingDropdown') assetRatingDropdown!: ObjectDropdownComponent;
  @ViewChild('baseVoltagePrimaryDropdown') baseVoltagePrimaryDropdown!: ObjectDropdownComponent;
  @ViewChild('baseVoltageSecondaryDropdown') baseVoltageSecondaryDropdown!: ObjectDropdownComponent;
  
  editModeParentClass: string = '';
  editModeAssetName: string = '';

  ngOnChanges(changes: SimpleChanges): void {
    const change = changes['selectedPtId'];
    if(!change) return;

    const newValue = change.currentValue;

    if(newValue && newValue.value !== 0){
      this.isEdit = true;
      this.getById(newValue.value);
    } else {
      this.isEdit = false;
      this.resetForm();           
    }
  }

  mapStringToVoltage(voltageString: string): Voltage {
    const voltageMap: { [key: string]: Voltage } = {
      'LV': Voltage.LV,
      'MV': Voltage.MV,
      'HV': Voltage.HV
    };
    
    return voltageMap[voltageString] || Voltage.LV;
  }
    
  selectedPowerTransformer: EditPowerTransformerDto = new EditPowerTransformerDto({
    substationTemplateInstanceId: null,
    name: '',
    primaryWindingBaseVoltageId: 0,
    secondaryWindingBaseVoltageId: 0
  });

  displayBaseVoltage: boolean = false;
  baseVoltage: string = '';
  
  selectedSubstationTemplate: number = 0;
  selectedSubstationTemplateVoltage!: Voltage;
  substationTemplateInstanceValue: SelectSubstationDto | null = null;
  powerTransformerInitialValue: SelectPowerTransformerDto | null = null;
  updatedRegionId: number | null = 0;
  baseVoltages: any[] = [];
  selectedAssetRating: AssetRating | null = null;
  utilityId:number | null = 0;

  constructor(
    private geographicalRegionService: GeographicalRegionService,
    private toastr: ToastrService, 
    private cimSubstationService: CimSubstationService,
    private powerTransformerService: PowerTransformerService,
    private baseVoltageService: BaseVoltageService,
    private utilitySharedService: UtilitySharedService
  ){
    this.utilityId = utilitySharedService.getUtilityId();
  }

  ngOnInit(): void {
    this.getAllGeographicalRegionsForSelect();
    this.getAllSubstationTemplateForSelect();
    this.getAllBaseVoltagesForSelect();
    if(this.selectedPtId !== null && this.selectedPtId.value !== null && this.selectedPtId.value !== 0){
      this.isEdit = true;
      this.getById(this.selectedPtId?.value);
    }
    this.initialVoltage = Voltage.LV;
  }

  save(){
    
    if (!this.selectedPowerTransformer.substationTemplateInstanceId) {
      this.toastr.warning('Please select a substation');
      return;
    }
    
    if (!this.selectedPowerTransformer.name || this.selectedPowerTransformer.name.trim() === '') {
      this.toastr.warning('Please enter transformer name');
      return;
    }
    
    if (!this.selectedPowerTransformer.primaryWindingBaseVoltageId) {
      this.toastr.warning('Please select primary winding voltage');
      return;
    }
    
    if (!this.selectedPowerTransformer.secondaryWindingBaseVoltageId) {
      this.toastr.warning('Please select secondary winding voltage');
      return;
    }

    if(this.selectedPtId?.value){
      this.selectedPowerTransformer.id = this.selectedPtId.value;
    }

    if(this.selectedAssetRating){
      this.selectedPowerTransformer.assetRatingId = this.selectedAssetRating.id;
    }

    this.powerTransformerService.create(this.selectedPowerTransformer).subscribe({
      next: (response: any) => {
        const responseData = response.body;
        if(responseData.status == 'OK')
        {
          this.toastr.success(`Power transformer ${this.isEdit ? 'updated' : 'saved'} successfully`);
        }
        else{
          this.toastr.error(`Error ${this.isEdit ? 'updating' : 'saving/creating'} power transformer`);
        }
        this.resetForm();
        this.closeEditModal?.nativeElement?.click();
        this.ptSaved.emit();
      },
      error: () => {
        this.toastr.error(`Error ${this.isEdit ? 'updating' : 'saving/creating'} power transformer`);
      }
    });
  }

  getAllGeographicalRegionsForSelect() {
    this.geographicalRegionService.getAllForSelect().subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.geoRegions = responseData.data.map((geoRegion: GeographicalRegion) => ({
            ...geoRegion,
            isExpanded: false,
          }));
        } else if (response?.status === 204) {
          this.geoRegions = [];
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occurred while loading regions');
      },
    });
  }

  getAllSubstationTemplateForSelect() {
    this.cimSubstationService.getStats().subscribe({
      next: (response: any) => {
        const responseData = response.body;
        if (responseData?.status === 'OK') {
          this.substationTemplateOptions = responseData.data.map(
            (item: any) => new SubstationTemplateForSelectDataOut(item)
          );
        } else if (response?.status !== 'OK') {
          this.substationTemplateOptions = [];
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occurred while loading substation templates');
      },
    });
  }

  onSelectSubstationTemplate(obj: SubstationTemplateForSelectDataOut | null) {
    if(obj != null && obj.id != null){
      this.selectedSubstationTemplate = obj.id;
      this.selectedSubstationTemplateVoltage = obj.voltageClass;
      this.filterAssetRatingsByVoltage();      
    } else {
      this.filteredAssetRatings = [];
    }
  }

  filterAssetRatingsByVoltage() {
    if (!this.selectedSubstationTemplateVoltage) {
      this.filteredAssetRatings = [];
      return;
    }

    if (this.selectedSubstationTemplateVoltage === Voltage.LV) {
      this.filteredAssetRatings = this.assetRatings.filter(rating => 
        rating.kvaRating?.toLowerCase().includes('kva') && 
        !rating.kvaRating?.toLowerCase().includes('mva')
      );
    } else if (this.selectedSubstationTemplateVoltage === Voltage.MV || 
              this.selectedSubstationTemplateVoltage === Voltage.HV) {
      this.filteredAssetRatings = this.assetRatings.filter(rating => 
        rating.kvaRating?.toLowerCase().includes('mva')
      );
    } else {
      this.filteredAssetRatings = [];
    }
  }

  onSelectSubstationTemplateInstance(obj: SelectSubstationDto | null){
    if(obj?.id){
      this.selectedPowerTransformer.substationTemplateInstanceId = obj.substationTemplateInstanceId;
      this.substationTemplateInstanceValue = obj;
    }
  }

  getAllPowerTransformers(substationId: number){
    this.powerTransformerService.getAllPowerTransformersFromSubstationId(substationId).subscribe({
      next: (response: any) => {
        const responseData = response;
        if (responseData?.status === 'OK') {
          this.powerTransformerOptions = responseData.data;
        } else if (response?.status !== 'OK') {
          this.powerTransformerOptions = [];
        }
      },
      error: (error) => {
        this.toastr.error('Error occurred while loading power transformer options');
      },
    });
  }

  onSearchTextChange(inputText: string){
    if (this.selectedSubstationTemplate > 0) {
      this.getAllSubstationInstancesForType(this.selectedSubstationTemplate, inputText);
    }
  }

  getAllSubstationInstancesForType(templateId: number, searchTerm: string = ''){
    this.dataIn.templateId = templateId;
    this.dataIn.searchTerm = searchTerm;
    this.cimSubstationService.getAllForSelect(this.dataIn).subscribe({
      next: (response: any) => {
        const responseData = response.body;
        if (responseData?.status === 'OK') {
          this.substationOptions = responseData.data;
        } else if (response?.status !== 'OK') {
          this.substationOptions = [];
        }
      },
      error: (error) => {
        this.toastr.error('Error occurred while loading substation options');
      },
    });
  }

  onSelectPowerTransformer(obj: SelectPowerTransformerDto | null){
    if(obj?.id){
      this.baseVoltage = obj.baseVoltage;
      this.displayBaseVoltage = true;
    }
  }

  onSelectGeographicalRegion(obj: GeographicalRegion | null) {
    if (obj)
      this.updatedRegionId = obj.id;
  }

  getAllBaseVoltagesForSelect() {
    this.baseVoltageService.getAllForMappings(this.utilityId!).subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.baseVoltages = responseData.data
        } else if (response?.status === 204) {
          this.baseVoltages = [];
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occurred while loading base voltages');
      },
    });
  }

  onAssetRatingSelect(obj: AssetRating | null){
    this.selectedAssetRating = obj;
  }

  onPrimaryWindingSelect(obj: any) {
    if (obj?.id) {
      this.selectedPowerTransformer.primaryWindingBaseVoltageId = obj.id;
    }
  }
  
  onSecondaryWindingSelect(obj: any) {
    if (obj?.id) {
      this.selectedPowerTransformer.secondaryWindingBaseVoltageId = obj.id;
    }
  }

  resetForm() {
    this.isEdit = false;
    this.editModeParentClass = '';
    this.editModeAssetName = '';
    this.substationTemplateDropdown?.selectItem(null);
    this.substationTemplateInstanceDropdown?.selectItem(null);
    this.assetRatingDropdown?.selectItem(null);
    this.baseVoltagePrimaryDropdown?.selectItem(null);
    this.baseVoltageSecondaryDropdown?.selectItem(null);
    this.selectedPowerTransformer.name = '';
    this.selectedAssetRating = null;
    this.selectedPowerTransformer.substationTemplateInstanceId = null;
    this.selectedPowerTransformer.primaryWindingBaseVoltageId = 0;
    this.selectedPowerTransformer.secondaryWindingBaseVoltageId = 0;
    this.filteredAssetRatings = [];
    this.selectedSubstationTemplateVoltage = undefined as any;

    if (this.isOpenedFromSubstation){
      this.selectedPowerTransformer.substationTemplateInstanceId = this.substationTemplateInstanceId;
      this.selectedSubstationTemplateVoltage = this.substationVoltage;
      this.filterAssetRatingsByVoltage();
    }
  }

  getById(ptId: number){
    this.powerTransformerService.getById(ptId).subscribe({
      next: (response: any) => {
        const responseData = response.body;
        
        if (responseData?.status === 'OK' && responseData?.data) {
          const data = responseData.data;
          this.editModeParentClass = data.substationTemplate?.className || '';
          if (data.substationTemplate?.voltageClass) {
            this.selectedSubstationTemplateVoltage = this.mapStringToVoltage(data.substationTemplate?.voltageClass);
            this.filterAssetRatingsByVoltage();
          }
          this.editModeAssetName = data.substationName || '';
          
          this.selectedPowerTransformer.name = data.name || '';
          this.selectedPowerTransformer.substationTemplateInstanceId = data.substationTemplateInstanceId || null;
          
          if (data.primaryWinding?.id) {
            this.selectedPowerTransformer.primaryWindingBaseVoltageId = data.primaryWinding.id;
            
            const primaryVoltage = this.baseVoltages.find(bv => bv.id === data.primaryWinding.id);
            if (primaryVoltage) {
              setTimeout(() => {
                this.baseVoltagePrimaryDropdown?.selectItem(primaryVoltage);
              }, 100);
            }
          }
          
          if (data.secondaryWinding?.id) {
            this.selectedPowerTransformer.secondaryWindingBaseVoltageId = data.secondaryWinding.id;
            
            const secondaryVoltage = this.baseVoltages.find(bv => bv.id === data.secondaryWinding.id);
            if (secondaryVoltage) {
              setTimeout(() => {
                this.baseVoltageSecondaryDropdown?.selectItem(secondaryVoltage);
              }, 100);
            }
          }
          
          if (data.assetRatingId) {
            this.selectedPowerTransformer.assetRatingId = data.assetRatingId;
            
            const assetRating = this.assetRatings.find(ar => ar.id === data.assetRatingId);
            if (assetRating) {
              this.selectedAssetRating = assetRating;
              setTimeout(() => {
                this.assetRatingDropdown?.selectItem(assetRating);
              }, 100);
            } else {
              this.selectedAssetRating = null;
              setTimeout(() => {
                this.assetRatingDropdown?.selectItem(null);
              }, 100);
            }
          } else {
            this.selectedPowerTransformer.assetRatingId = null;
            this.selectedAssetRating = null;
            setTimeout(() => {
              this.assetRatingDropdown?.selectItem(null);
            }, 100);
          }

        }
      },
      error: (error) => {
        this.toastr.error('Error occurred while loading power transformer data');
      }
    });
  }
}